<template>
  <div class="card">
    <div class="card-header">
      Driver Device
    </div>
    <div class="p-6">
      <div class="text-gray-500">
        Enable this to send a message directly to the driver's device whenever this automation rule is triggered.
      </div>
      <label class="flex items-center mt-6 form-label">
        <toggle :value.sync="form.notify_driver" class="mr-2" /> 
        Send Message to Driver's Device
      </label>
      <label class="mt-6 form-label">Message to send to driver:</label>
      <input type="text" class="w-full form-input" ref="driverMessage" :class="{ 'opacity-25': !form.notify_driver }" v-model="form.driver_message" :disabled="!form.notify_driver" placeholder="Enter your message here">
    </div>
    <div class="p-6 border-t" v-if="enableOutput">
      <div class="text-gray-500">
        The output device (e.g. buzzer or light) connected to the unit will be activated until the driver logs in.
      </div>
      <label class="flex items-center mt-6 form-label">
        <toggle :value.sync="form.activate_output" :sync="true" :width="60" :labels="true" class="mr-4" /> 
        <div class="leading-tight">
          Activate LINK Output Device
        </div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DriverDeviceCard',

  props: {
    form: {
      type: Object,
      required: true
    },
    
    methods: {
      type: Object,
      required: true
    },

    enableOutput: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    'form.notify_driver': {
      handler (newVal, oldVal) {
        if (newVal === true) {
          this.$nextTick(() => {
            this.$refs.driverMessage.focus()
          })
        }
      }
    }
  }
}
</script>